import React from "react";
import BackAppBar from "components/app/BackAppBar";
import { useSelector } from "react-redux";
import { prop } from "ramda";
import BgView from "components/common/BgView";
import UserDetails from "./UserDeails";

export default function UserView() {
  const { userDetails } = useSelector(prop('user'));
  return (
    <BgView>
      <BackAppBar />
      <UserDetails User={userDetails} />
    </BgView>
  );
}
